/**
 * Authentifiziertes Seiten-Layout: lädt Meta (Header/Footer) und rendert
 * die aktive Route via <Outlet>. Meta wird einmal pro Mount geladen.
 *
 * D-089: Berichts-/Vorjahr aus Meta werden hier per <JahreProvider> für alle
 * Seiten bereitgestellt (eine Quelle: lib/jahre.tsx). Solange Meta lädt oder
 * fehlt, gilt der Fallback 2026/2025.
 */
import { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { api } from '../api/client';
import type { Meta } from '../types/snapshot';
import { Header } from './Header';
import { Footer } from './Footer';
import { JahreProvider, jahreAusMeta } from '../lib/jahre';

export function Layout() {
  const [meta, setMeta] = useState<Meta | null>(null);

  useEffect(() => {
    let active = true;
    api
      .getMeta()
      .then((m) => active && setMeta(m))
      .catch(() => active && setMeta(null));
    return () => {
      active = false;
    };
  }, []);

  const jahre = useMemo(() => jahreAusMeta(meta), [meta]);

  return (
    <JahreProvider jahre={jahre}>
      <div className="flex min-h-screen flex-col bg-bg">
        <Header meta={meta} />
        <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6">
          <Outlet />
        </main>
        <Footer meta={meta} />
      </div>
    </JahreProvider>
  );
}
